/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PluginType } from './PluginType';
import {
    PluginTypeFromJSON,
    PluginTypeFromJSONTyped,
    PluginTypeToJSON,
} from './PluginType';

/**
 * 
 * @export
 * @interface PluginMappingConfigResponse
 */
export interface PluginMappingConfigResponse {
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: any; }}
     * @memberof PluginMappingConfigResponse
     */
    config: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof PluginMappingConfigResponse
     */
    refId?: string;
    /**
     * 
     * @type {string}
     * @memberof PluginMappingConfigResponse
     */
    pluginId: string;
    /**
     * 
     * @type {PluginType}
     * @memberof PluginMappingConfigResponse
     */
    type: PluginType;
    /**
     * 
     * @type {string}
     * @memberof PluginMappingConfigResponse
     */
    id: string;
}



/**
 * Check if a given object implements the PluginMappingConfigResponse interface.
 */
export function instanceOfPluginMappingConfigResponse(value: object): value is PluginMappingConfigResponse {
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('pluginId' in value) || value['pluginId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PluginMappingConfigResponseFromJSON(json: any): PluginMappingConfigResponse {
    return PluginMappingConfigResponseFromJSONTyped(json, false);
}

export function PluginMappingConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PluginMappingConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'config': json['config'],
        'refId': json['refId'] == null ? undefined : json['refId'],
        'pluginId': json['pluginId'],
        'type': PluginTypeFromJSON(json['type']),
        'id': json['id'],
    };
}

export function PluginMappingConfigResponseToJSON(value?: PluginMappingConfigResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'config': value['config'],
        'refId': value['refId'],
        'pluginId': value['pluginId'],
        'type': PluginTypeToJSON(value['type']),
        'id': value['id'],
    };
}

